import jQuery from 'jquery';
import { Dropdown } from 'bootstrap';
import LazyLoad from 'vanilla-lazyload';
import LazyEmbed from 'lazyembed2';
import objectFitVideos from 'object-fit-videos';
import PageLoadedQueue from "./PageLoadedQueue";
import Viewport from "./Viewport";

window.Dropdown = Dropdown;
window.jQuery = window.$ = jQuery.noConflict();
window.LazyLoad = LazyLoad;
window.LazyEmbed = LazyEmbed;
window.objectFitVideos = objectFitVideos;
window.PageLoadedQueue = PageLoadedQueue;
window.Viewport = new Viewport();
window.viewport = window.Viewport.viewport;
